<template>
  <!--
    FS-113 (16/10/2026) — จำลองช่อง "จัดทำโดย" ของฟอร์ม PDF ในกรอบ preview ของ popup ลายเซ็น
      ผู้ใช้ต้องเห็นภาพแบบเดียวกับที่จะพิมพ์ออกมา ทั้งตอนเลือกไฟล์และตอนใช้ค่าเริ่มต้น

    ค่าทุกตัววัดจาก PDF จริงที่ BIRT render (FormSummaryStock.rptdesign cell 1017) หน่วย pt
    คูณเท่ากันทุกชิ้นด้วย --fss-pdf-scale = 1 ขนาดจริงเท่ารายงาน (16/10/2026 — เดิม ×2.5 → ×1.6667)
      ภาพลายเซ็น     1.1 × 0.55 in (79.2 × 39.6 pt) — BIRT ยืดภาพเต็มกรอบ ไม่รักษาสัดส่วน
                     (ตรวจแล้ว: ไฟล์ 670×894 / 500×500 / 300×95 ออกมา 79.2×39.6 pt ทุกไฟล์)
      กรอบ QR        1.75 × 0.4832 in (126 × 34.8 pt) — รอบแก้ (3) ขอบขาวบน/ล่างในภาพเหลือ 1 pt
                     (FS-131 19/10/2026 — แทน barcode เดิม 1.6 × 0.22 in · ภาพไฟล์เดียวกับที่ฝังใน PDF)
      ระบบเบียร์สด    11pt · เส้นจุด กว้าง 121.4 pt · ( จัดทำโดย ) 11pt
      ตำแหน่งวัดจาก PDF หลัง FS-131 รอบแก้ (4) : กรอบ QR 41.9 · เส้นจุด 73.4 · จัดทำโดย 88.7
        ลายเซ็น → QR 3 pt · QR → เส้นจุด 6 pt · เส้นจุด → ( จัดทำโดย ) 6 pt (หมึกจริง) · ไม่มี "ระบบเบียร์สด" ใต้กรอบ (ผู้ใช้สั่ง 19/10/2026)
  -->
  <div class="fss-pdfsig" :data-test="testId">
    <div class="fss-pdfsig__sign">
      <img
        v-if="src"
        :src="src"
        :alt="alt"
        class="fss-pdfsig__image"
        data-test="fss-pdfsig-image"
        @load="$emit('load', $event)"
        @click="$emit('zoom')"
      />
      <span v-else class="fss-pdfsig__empty" data-test="fss-pdfsig-empty">{{ emptyText }}</span>
    </div>
    <img
      class="fss-pdfsig__barcode"
      src="/images/fss-signature-qr-box.png"
      alt="QR ระบบเบียร์สด https://dbs.boonrawd.co.th"
      data-test="fss-pdfsig-barcode"
    />
    <div class="fss-pdfsig__text fss-pdfsig__dots" data-test="fss-pdfsig-dots">{{ dots }}</div>
    <div class="fss-pdfsig__text fss-pdfsig__by" data-test="fss-pdfsig-by">( จัดทำโดย )</div>
  </div>
</template>

<script>
export default {
  name: "FormSummaryStockSignaturePdfPreview",
  props: {
    src: { type: String, default: "" },
    alt: { type: String, default: "" },
    emptyText: { type: String, default: "ยังไม่มีภาพลายเซ็น" },
    testId: { type: String, default: "" },
  },
  data: function() {
    return {
      // เส้นจุดของฟอร์มเป็นตัวอักษร "." — วาดยาวเกินแล้วตัดที่ความกว้างจริง (121.4 pt)
      //   ฟอนต์บนเว็บไม่ใช่ Singha Water TH ความกว้างของจุดจึงต่างกันเล็กน้อย
      dots: new Array(120).join("."),
    };
  },
};
</script>

<style scoped>
/* ตำแหน่ง top ของแต่ละชิ้น = ระยะจากขอบบนภาพลายเซ็นใน PDF (pt) */
.fss-pdfsig {
  /* สเกล 1 = ขนาดจริงเท่ารายงาน (เท่ากับเปิด PDF ที่ซูม 100%) — ผู้ใช้สั่ง 16/10/2026
     เดิม ×2.5 → ×1.6667 ใหญ่กว่ารายงาน ทำให้ user สงสัย และภาพไฟล์เล็กถูกขยายจนแตก */
  --fss-pdf-scale: 1;
  position: relative;
  width: calc(126pt * var(--fss-pdf-scale)); /* กว้างสุด = กรอบเทา QR (FS-131) */
  height: calc(101pt * var(--fss-pdf-scale));
  margin: 0 auto;
  background-color: #fff;
  color: #000;
  /* เว็บยังไม่มีไฟล์ฟอนต์ Singha Water TH (มีเฉพาะฝั่ง BIRT) — ถ้าเครื่องไม่มีจะใช้ฟอนต์สำรอง
     ขนาด/ตำแหน่งยังตรง PDF แต่รูปตัวอักษรต่างเล็กน้อย */
  font-family: "Singha Water TH", "Singha Water TH BIRT", "TH Sarabun New", "Sarabun", sans-serif;
  font-weight: 400;
}

.fss-pdfsig > * {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}

.fss-pdfsig__sign {
  top: 0;
  width: calc(79.2pt * var(--fss-pdf-scale));
  height: calc(39.6pt * var(--fss-pdf-scale));
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ยืดเต็มกรอบ 2:1 แบบเดียวกับ BIRT */
.fss-pdfsig__image {
  display: block;
  width: 100%;
  height: 100%;
  cursor: zoom-in;
}

.fss-pdfsig__empty {
  color: #a7abc3;
  font-size: 0.9rem;
  white-space: nowrap;
}

/* FS-131 — กรอบ QR (เดิม barcode 115.2 × 15.8 pt) · ห่างลายเซ็น 3 pt · ห่างเส้นจุด 6 pt (รอบแก้ 4) */
.fss-pdfsig__barcode {
  top: calc(41.9pt * var(--fss-pdf-scale));
  width: calc(126pt * var(--fss-pdf-scale));
  height: calc(34.8pt * var(--fss-pdf-scale));
}

.fss-pdfsig__text {
  font-size: calc(11pt * var(--fss-pdf-scale));
  line-height: calc(11.9pt * var(--fss-pdf-scale));
  height: calc(11.9pt * var(--fss-pdf-scale));
  white-space: nowrap;
  text-align: center;
}

.fss-pdfsig__dots {
  top: calc(73.4pt * var(--fss-pdf-scale));
  width: calc(121.4pt * var(--fss-pdf-scale));
  overflow: hidden;
  text-align: left;
}

.fss-pdfsig__by {
  top: calc(88.7pt * var(--fss-pdf-scale));
}
</style>



// WEBPACK FOOTER //
// App/Components/PrintSummary/FormSummaryStockSignaturePdfPreview.vue